<template>
  <v-card flat>
    <v-card-text>
      <slot name="content"></slot>
    </v-card-text>
    <v-card-actions>
      <slot name="before-actions"></slot>
      <v-row>
        <v-col
          cols="12"
          class="d-flex flex-wrap gap justify-center justify-md-end"
        >
          <v-btn
            outlined
            :block="$vuetify.breakpoint.xs"
            @click="$emit('cancel', $event)"
          >
            Cancelar
          </v-btn>
          <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
          <v-btn
            v-if="canPrevious"
            class="mx-2"
            outlined
            :block="$vuetify.breakpoint.xs"
            @click="$emit('previous', $event)"
            >Anterior</v-btn
          >
          <v-btn
            v-if="canNext"
            class="mx-2"
            elevation="0"
            color="secondary"
            :disabled="invalid || disabledNext"
            :block="$vuetify.breakpoint.xs"
            @click="$emit('next', $event)"
          >
            Siguiente
          </v-btn>

          <v-btn
            v-if="canSubmit"
            class="mx-2"
            color="primary"
            :disabled="invalid || disabledNext"
            :block="$vuetify.breakpoint.xs"
            @click="$emit('submit', $event)"
          >
            Guardar
          </v-btn>
        </v-col>
      </v-row>
      <slot name="after-actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    invalid: {
      type: Boolean,
      default: false
    },
    canPrevious: {
      type: Boolean,
      required: true
    },
    canNext: {
      type: Boolean,
      required: true
    },
    canSubmit: {
      type: Boolean,
      default: false
    },
    disabledNext: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style></style>
